<div class="message-modal">
  @if (image) {
    <img [src]="image" alt="" aria-hidden="true" class="header-image">
  }
  <h1 class="title" id="modal-title">{{ title }}</h1>
  <p class="body">{{ text }}</p>
  <div class="action">
    <button (click)="ok()" class="button primary" i18n="Message Box@@popup.btn.understood">Alles klar</button>
  </div>
</div>
